module.exports = __webpack_public_path__ + "static/media/hammer.823bdd7c.png";